export enum ETAPAS {
  DEFAULT = '0',
  PASO1 = '1',
  PASO2 = '2',
  PASO3 = '3',
  PASO4 = '4',
}
